import { jsx as _jsx } from "react/jsx-runtime";
// import utils
import { forwardRef } from "react";
import { SdbDrawer, NavigationRail } from "./Drawer.components.js";
const ComponentMap = {
    navigationRail: NavigationRail,
    default: SdbDrawer,
};
export const DrawerAtomComponent = forwardRef(function DrawerAtom({ type = "default", ...props }, ref) {
    const Component = ComponentMap[type];
    return _jsx(Component, { "data-testid": "Drawer", ...props, ref: ref });
});
export default DrawerAtomComponent;
